import { Injectable } from '@angular/core';
import { NavbarConfigurationService } from './navbar-configuration.service';
import { SettingService } from './setting.service';
import { Router } from '@angular/router';
import { HomePageService } from 'src/app/services/home-page.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { NewsBlogsService } from './news-blogs.service';
import { NavController } from '@ionic/angular';
import { GamesService } from './games.service';
import { IStore, StoreService } from 'src/app/store/services/store.service';
import { filter, finalize, switchMap, take } from 'rxjs';
import { MenuService } from 'src/app/store/services/menu.service';
import { StatusConfigurationService } from 'src/app/account/services/status-configuration.service';
import { RewardsService } from './rewards.service';
import { AchievementsService } from './achievements.service';
import { OrderService } from 'src/app/store/services/order.service';

@Injectable({
  providedIn: 'root',
})
export class PreloaderService {

  
  priorityload: string = "";

  constructor(
    private settingService: SettingService,
    private navbarConfigurationService: NavbarConfigurationService,
    private router: Router,
    private homePageService: HomePageService,
    private auth: AuthService,
    private newsBlogsService: NewsBlogsService,
    private navCtrl: NavController,
    private gamesService: GamesService,
    private storeService: StoreService,
    private menuService: MenuService,
    private statusConfigurationService: StatusConfigurationService,
    private rewardsService: RewardsService,
    private achievementsService: AchievementsService,
    private orderService: OrderService,
  ) {

  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////
  // preloading section
  async initialize(): Promise<void> {
    this.waitForConfiguration().then(() => {

      if (this.settingService.configuration.navBarConfiguration) {
        // Preload asynchronously
        this.preloadingAllnavbarIcons();
        
      }

      // Priority homepage images can also be async
      if (this.router.url === '/home' || this.router.url === '/' || this.router.url === '') {
        this.priorityload = "home";

        this.preloadingHomepageImages();
        this.preloadingNews();
        this.preloadingBlogs();
        this.preloadingGames();
      }
    });

    // temporarily
    // this.navCtrl.navigateRoot('/home');


    // load the other ressources here
    this.preloadingStores().subscribe();
    //this.preloadingSingleMenu();

    // preloading the status
    this.waitForConfiguration().then(() => {
      if(this.priorityload != "home") {
        // Priority homepage images can also be async
        this.preloadingHomepageImages();
        this.preloadingNews();
        this.preloadingBlogs();
        this.preloadingGames();
      }
      

      this.preloadingStatusRewards();
      this.preloadingRewards();
      this.preloadingAchievements();


      //this.preloadingOrderHistory(); // be careful, this preloads data but also may not collect the recent orders without refreshing the page
    });
    

  }

  private waitForConfiguration(): Promise<void> {
    return new Promise((resolve) => {
      const check = () => {
        if (this.settingService.configuration) {
          resolve();
        } else {
          setTimeout(check, 10); // check again in 10ms
        }
      };
      check();
    });
  }

  preloadingStatusRewards() {
    var statusRequest = {
      merchantId: this.settingService.getMerchantId()
    }

    this.statusConfigurationService.getStatus(statusRequest).subscribe(async val => {});
    return;
  }

  preloadingRewards() {
    var rewardsRequest = {
      merchantId: this.settingService.getMerchantId()
    }

    this.rewardsService.getRewards(rewardsRequest).subscribe(async val => {});
    return;
  }

  preloadingAchievements() {
    var achievementsRequest = {
      merchantId: this.settingService.getMerchantId()
    }

    this.achievementsService.getAchievements(achievementsRequest).subscribe(async val => {});
    return;
  }

  preloadingOrderHistory() {
    this.orderService.findMemberAllPlacedOrder().subscribe(async val => {});
    this.orderService.findMemberAllPlacedOrderShipping().subscribe(async val => {});
    return;
  }

  preloadingNews() {
    var newsRequest;
    if(this.auth.isAuthenticated) {
      newsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: this.auth.memberId.toString()
      }
    } else {
      newsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: ""
      }
    }
    
    this.newsBlogsService.getNews(newsRequest).subscribe(async val => {});
    return;
  }

  preloadingBlogs() {
    var blogsRequest;
    if(this.auth.isAuthenticated) {
      blogsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: this.auth.memberId.toString()
      }
    } else {
      blogsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: ""
      }
    }
    
    
    this.newsBlogsService.getBlogs(blogsRequest).subscribe(async val => {});
    return;
  }

  preloadingGames() {
    var gamesRequest = {
      merchantId: this.settingService.getMerchantId()
    }

    this.gamesService.getGames(gamesRequest).subscribe(async val => {});
    return;
  }

  preloadingStores(){
    //this.storeService.getStores(false, "standard");

    /*
    return this.settingService.settingsReady$.pipe(
      take(1), // wait until settings loaded
      switchMap(() => this.storeService.getStores(false, "standard").pipe(take(1))),
        switchMap(stores => this.menuService.getMenu(stores[0].id, null, true))
    );
    */
    return this.settingService.settingsReady$.pipe(
      take(1),
      switchMap(() => this.storeService.getStores(true, null, true).pipe(take(1)))
    );

  }

  preloadingSingleMenu() {
    this.storeService.storesPreload$.pipe(
      filter(stores => stores && stores.length > 0), // wait until array has at least one element
      take(1) // automatically complete after first emission
    ).subscribe(stores => {
      const storeId = stores[0].id;
      this.menuService.getMenu(storeId, null, true);
    });
  }

  async preloadingAllnavbarIcons() {

    const promises: Promise<any>[] = [];

    // only load them if there's value
    if(this.settingService.configuration?.navBarConfiguration?.homePageActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.homePageActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.homePagePassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.homePagePassiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.contactUsActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.contactUsActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.contactUsPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.contactUsPassiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.locationsActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.locationsActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.locationsPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.locationsPassiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.loginActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.loginActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.loginPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.loginPassiveImageShortName)
      );
    }

    if(this.settingService.configuration?.navBarConfiguration?.logoutActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.logoutActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.logoutPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.logoutPassiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.myOrderActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.myOrderActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.myOrderPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.myOrderPassiveImageShortName)
      );
    }

    if(this.settingService.configuration?.navBarConfiguration?.offersActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.offersActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.offersPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.offersPassiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.orderActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.orderActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.orderPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.orderPassiveImageShortName)
      );  
    }

    if(this.settingService.configuration?.navBarConfiguration?.profileActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.profileActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.profilePassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.profilePassiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.reservationActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.reservationActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.reservationPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.reservationPassiveImageShortName)
      );
    }

    if(this.settingService.configuration?.navBarConfiguration?.rewardsActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.rewardsActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.rewardsPassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.rewardsPassiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.tableActiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.tableActiveImageShortName)
      );
    }
    if(this.settingService.configuration?.navBarConfiguration?.tablePassiveImageShortName) {
      promises.push(
        this.navbarConfigurationService.fetchImage(this.settingService.configuration?.navBarConfiguration?.tablePassiveImageShortName)
      );
    }

    await Promise.all(promises);

    this.navbarConfigurationService.isNavBarImageLoaded = true;
  }

  async preloadingHomepageImages() {

    const promises: Promise<any>[] = [];

     if(this.settingService.configuration?.homePageConfiguration?.homePageVersion1) {
      for(var i = 0; i < this.settingService.configuration?.homePageConfiguration?.homePageVersion1.length; i++){
        if(this.settingService.configuration?.homePageConfiguration?.homePageVersion1[i].desktopImageShortName){
          promises.push(
            this.homePageService.fetchImage(this.settingService.configuration?.homePageConfiguration?.homePageVersion1[i].desktopImageShortName)
          );
          promises.push(
            this.homePageService.fetchImage(this.settingService.configuration?.homePageConfiguration?.homePageVersion1[i].desktopFrImageShortName)
          );
          promises.push(
            this.homePageService.fetchImage(this.settingService.configuration?.homePageConfiguration?.homePageVersion1[i].desktopImageShortNameForeGround)
          );
          promises.push(
            this.homePageService.fetchImage(this.settingService.configuration?.homePageConfiguration?.homePageVersion1[i].desktopFrImageShortNameForeGround)
          );
          promises.push(
            this.homePageService.fetchImage(this.settingService.configuration?.homePageConfiguration.homePageVersion1[i].mobileImageShortName)
          );
          promises.push(
            this.homePageService.fetchImage(this.settingService.configuration.homePageConfiguration?.homePageVersion1[i].mobileFrImageShortName)
          );
          promises.push(
            this.homePageService.fetchImage(this.settingService.configuration?.homePageConfiguration?.homePageVersion1[i].mobileImageShortNameForeGround)
          );
          promises.push(
            this.homePageService.fetchImage(this.settingService.configuration?.homePageConfiguration?.homePageVersion1[i].mobileFrImageShortNameForeGround)
          );
        }
      }
    } 
    await Promise.all(promises);

    this.homePageService.isHomePageImageLoaded = true;
  }
              
  /////////////////////////////////////////////////////////////////////////////////////////////////////
}
